import {Moment} from 'moment';
import {DocumentCreatePayload} from '../../../../../../document/common/impl/service/payload/documentCreate.payload';
import {PayloadWithSummary} from '../../../../../../core/service/payload/payloadWithSummary';
import {SaleInvoiceSaveReportPayload} from '../../../impl/service/payload/saleInvoiceSaveReport.payload';

export class SaleInvoiceSavePayload extends PayloadWithSummary {

    number: string;
    date: Moment;
    statusValue: string;
    saleId: number;
    document: DocumentCreatePayload;
    report: SaleInvoiceSaveReportPayload;
    remark: string;
    documentLabel: string;
    bookId: number;
}
